import React, { useCallback, useEffect } from "react";
import { Card } from "antd";
import Title from "antd/es/typography/Title";
import StackedSingleBarChart from "./components/StackedSingleBarChart";
import { getPaidByAge } from "../ducks/service";
import LoaderTsx from "../../../Loader.tsx";

import { useQuery } from "@tanstack/react-query";
import { useDashboardFilterContext } from "../../hooks/DashboardFilterProvider";

function BookingsByAge() {
  const filterData = useDashboardFilterContext();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["getPaidByAge",filterData?.queryParams],
    queryFn: () => getPaidByAge(filterData?.queryParams),
    staleTime: 1000 * 60 * 5, // ✅ 5 minutes
    refetchOnWindowFocus: false, // 👈 disable auto refetch when window regains focus
  });

  // whenever queryParams changes, trigger refetch
  // useEffect(() => {
  //   if (filterData?.queryParams) {
  //     refetch();
  //   }
  // }, [filterData?.queryParams, refetch]);

  return (
    <Card
      style={{
        backgroundColor: "#FFFFFF",
        borderRadius: 20,
        border: "1px solid #E9E9E9",
        boxShadow: "none",
      }}
    >
      {isLoading ? (
        <LoaderTsx height={"30vh"} />
      ) : (
        <>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Title
              level={5}
              style={{
                margin: 0,
                color: "#1F5782",
                textTransform: "uppercase",
                fontWeight: 400,
              }}
            >
              <span style={{ fontWeight: 700 }}>BOOKINGS</span>{" "}
              <span style={{ fontWeight: 400 }}>BY AGE</span>
            </Title>
          </div>

          <StackedSingleBarChart
            totalCount={data?.result?.totalCount}
            ageBuckets={data?.result?.ageBuckets}
          />
        </>
      )}
    </Card>
  );
}

export default BookingsByAge;
